export const PAGE_IN_POPUP_STATE_CLEAR = 'PAGE_IN_POPUP:STATE:CLEAR';

export const clearPageInPopup = () => ({
    type: PAGE_IN_POPUP_STATE_CLEAR
});
